// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Blogs — compact table layout */

.bm-page {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 148px);
  min-height: 420px;
  max-height: calc(100vh - 136px);
}

.bm-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.bm-search {
  flex: 1 1;
  min-width: 160px;
  max-width: 280px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
}

.bm-select {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
  color: #475569;
}

.bm-toolbar-note {
  font-size: 15px;
  color: #94a3b8;
}

.bm-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.bm-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.bm-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.bm-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.bm-btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.bm-btn--primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.bm-btn--danger {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.bm-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 15px;
  flex-shrink: 0;
}

.bm-toast button {
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.bm-toast--ok {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #bbf7d0;
}

.bm-toast--err {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.bm-table-panel {
  flex: 1 1;
  min-height: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.bm-table-scroll {
  overflow: auto;
  flex: 1 1;
  min-height: 0;
}

.bm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.bm-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fafbfc;
  padding: 9px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #e2e8f0;
}

.bm-table thead th:last-child {
  width: 120px;
  text-align: right;
}

.bm-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
}

.bm-table tbody tr:hover {
  background: #f8fafc;
}

.bm-title {
  display: block;
  font-weight: 600;
  color: #0f172a;
}

.bm-excerpt {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 320px;
}

.bm-meta {
  font-size: 15px;
  color: #64748b;
}

.bm-badge {
  font-size: 14px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  text-transform: uppercase;
}

.bm-badge--published {
  background: #dcfce7;
  color: #166534;
}

.bm-badge--draft {
  background: #f1f5f9;
  color: #64748b;
}

.bm-badge--cat {
  background: #eff6ff;
  color: #1d4ed8;
  text-transform: capitalize;
}

.bm-actions {
  display: flex;
  gap: 4px;
  justify-content: flex-end;
}

.bm-icon-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.bm-table tbody tr:hover .bm-icon-btn {
  color: #94a3b8;
}

.bm-icon-btn:hover:not(:disabled) {
  background: #f1f5f9;
  color: #475569;
}

.bm-icon-btn--danger:hover:not(:disabled) {
  background: #fef2f2;
  color: #dc2626;
}

.bm-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-top: 1px solid #f1f5f9;
  flex-shrink: 0;
  font-size: 15px;
  color: #64748b;
}

.bm-pagination-btns {
  display: flex;
  gap: 6px;
}

.bm-empty,
.bm-loading {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #94a3b8;
  font-size: 15px;
  padding: 24px;
}

.bm-spin {
  animation: bm-spin 0.8s linear infinite;
}

@keyframes bm-spin {
  to { transform: rotate(360deg); }
}

.bm-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  padding: 16px;
}

.bm-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
}

.bm-modal--lg {
  max-width: 640px;
}

.bm-modal--sm {
  max-width: 400px;
}

.bm-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.bm-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.bm-modal-close {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bm-modal-body {
  padding: 16px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.bm-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
}

.bm-field {
  margin-bottom: 12px;
}

.bm-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
}

.bm-field input,
.bm-field select,
.bm-field textarea {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  box-sizing: border-box;
}

.bm-field textarea {
  min-height: 80px;
  resize: vertical;
}

.bm-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.bm-form-row .bm-field {
  margin-bottom: 0;
}

.bm-toggle-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: #475569;
}

.bm-confirm-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fef2f2;
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.bm-confirm-text {
  text-align: center;
  font-size: 15px;
  color: #64748b;
}

@media (max-width: 768px) {
  .bm-page {
    height: auto;
    max-height: none;
  }

  .bm-form-row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/website/BlogsManager.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Blogs — compact table layout */\n\n.bm-page {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: calc(100vh - 148px);\n  min-height: 420px;\n  max-height: calc(100vh - 136px);\n}\n\n.bm-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.bm-search {\n  flex: 1;\n  min-width: 160px;\n  max-width: 280px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n}\n\n.bm-select {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n  color: #475569;\n}\n\n.bm-toolbar-note {\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.bm-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.bm-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.bm-btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.bm-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.bm-btn--primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.bm-btn--primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.bm-btn--danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.bm-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.bm-toast button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.bm-toast--ok {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #bbf7d0;\n}\n\n.bm-toast--err {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.bm-table-panel {\n  flex: 1;\n  min-height: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.bm-table-scroll {\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.bm-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 15px;\n}\n\n.bm-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #fafbfc;\n  padding: 9px 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.bm-table thead th:last-child {\n  width: 120px;\n  text-align: right;\n}\n\n.bm-table tbody td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f8fafc;\n  vertical-align: middle;\n}\n\n.bm-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.bm-title {\n  display: block;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.bm-excerpt {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 320px;\n}\n\n.bm-meta {\n  font-size: 15px;\n  color: #64748b;\n}\n\n.bm-badge {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 999px;\n  text-transform: uppercase;\n}\n\n.bm-badge--published {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.bm-badge--draft {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.bm-badge--cat {\n  background: #eff6ff;\n  color: #1d4ed8;\n  text-transform: capitalize;\n}\n\n.bm-actions {\n  display: flex;\n  gap: 4px;\n  justify-content: flex-end;\n}\n\n.bm-icon-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #cbd5e1;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bm-table tbody tr:hover .bm-icon-btn {\n  color: #94a3b8;\n}\n\n.bm-icon-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.bm-icon-btn--danger:hover:not(:disabled) {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n.bm-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-top: 1px solid #f1f5f9;\n  flex-shrink: 0;\n  font-size: 15px;\n  color: #64748b;\n}\n\n.bm-pagination-btns {\n  display: flex;\n  gap: 6px;\n}\n\n.bm-empty,\n.bm-loading {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #94a3b8;\n  font-size: 15px;\n  padding: 24px;\n}\n\n.bm-spin {\n  animation: bm-spin 0.8s linear infinite;\n}\n\n@keyframes bm-spin {\n  to { transform: rotate(360deg); }\n}\n\n.bm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  padding: 16px;\n}\n\n.bm-modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 32px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);\n}\n\n.bm-modal--lg {\n  max-width: 640px;\n}\n\n.bm-modal--sm {\n  max-width: 400px;\n}\n\n.bm-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.bm-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.bm-modal-close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bm-modal-body {\n  padding: 16px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.bm-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.bm-field {\n  margin-bottom: 12px;\n}\n\n.bm-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 5px;\n}\n\n.bm-field input,\n.bm-field select,\n.bm-field textarea {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.bm-field textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.bm-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.bm-form-row .bm-field {\n  margin-bottom: 0;\n}\n\n.bm-toggle-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  color: #475569;\n}\n\n.bm-confirm-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #fef2f2;\n  color: #dc2626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 12px;\n}\n\n.bm-confirm-text {\n  text-align: center;\n  font-size: 15px;\n  color: #64748b;\n}\n\n@media (max-width: 768px) {\n  .bm-page {\n    height: auto;\n    max-height: none;\n  }\n\n  .bm-form-row {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
